// Copyright (c) 2025 Initiumnet Technologies. All Rights Reserved.

/*
 * "userSignupRequest.js": This file will have user related all structure definition.
 */


const SignupRequestStructure = {
  userId: "",            // Optional: can be provided or autogenerated
  name: "",
  email: "",
  dateOfBirth: "",
  profilePicture: "",    // URL or Base64 Encoded Image
  placeOfBirth: "",
  password: "",
  city: "",
  country: "",
  gender: "",
  nationality: "",
  mobileNo: "",
  acceptTerms: 0,         // 1 if accepted, 0 if not
  userType: "",
};

export default SignupRequestStructure;